import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';
import { text } from '@fortawesome/fontawesome-svg-core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core'
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DhlFormControlEventData } from '../../dhl-form/models/dhl-form-control-event-data';
import { CommonConfig } from '../../../common/configuration/common.config';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'app-overview-v2',
    templateUrl: './overview-v2.component.html',
    styleUrls: ['./overview-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewV2Component implements OnInit, AfterViewChecked, AfterViewInit {
  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  orderId;
  orderDetailsData: any;
  customerName:any;
  hereMapId: string = '';
  hereMapCode: string = '';
  mapConfig = {};
  overview:any;
  startData = {};
  finishData = {};
  isHandset$: Observable<boolean> =
  this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  selfServiceConfig : boolean = false;
  constructor(private route: ActivatedRoute, private apiService: AppService,private breakpointObserver: BreakpointObserver,private changeDetector: ChangeDetectorRef,public translate: TranslateService) {
    this.mapConfig = CommonConfig.mapConfig;
  }
  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }
  ngAfterViewInit(){
     this.hereMapId = CommonConfig.HERE_MAP_ID;
    this.hereMapCode = CommonConfig.HERE_MAP_CODE;
    this.customerName = localStorage.getItem('customerName');
    //   this.startData['lat'] = parseFloat(this.overview.mapData.start.lat);
    // this.startData['lng'] = parseFloat(this.overview.mapData.start.lng);

    // this.finishData['lat'] = parseFloat(this.overview.mapData.finish.lat);
    // this.finishData['lng'] = parseFloat(this.overview.mapData.finish.lng);
    // console.log("this.overview",this.overview)
    // console.log("values",this.overview.startMapData)
    // console.log("this.startData", this.startData)
    // console.log("this.finishData",this.finishData)
  }
  ngOnInit() {
    let orderDataUrl;
    this.mapConfig = this.configData.mapConfig;
    if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    // this.orderId = this.route.snapshot.params.id;
    // this.hereMapId = CommonConfig.HERE_MAP_ID;
    // this.hereMapCode = CommonConfig.HERE_MAP_CODE;
    // this.customerName = localStorage.getItem('customerName');
    // this.orderDetailsData = this.frmGroup.value;
    // this.startData['lat'] = parseFloat(this.orderDetailsData.mapData.start.lat);
    // this.startData['lng'] = parseFloat(this.orderDetailsData.mapData.start.lng);

    // this.finishData['lat'] = parseFloat(this.orderDetailsData.mapData.finish.lat);
    // this.finishData['lng'] = parseFloat(this.orderDetailsData.mapData.finish.lng);
    console.log("values",this.overview)
    this.getDataFromParent()
   
  }
  getDataFromParent(){
    if(this.configData && this.configData.events && this.configData.events.length > 0){
      let events = this.configData.events;
      let eventData: DhlFormControlEventData = {
        event: events[0].event,
        eventData: events[0],
        action: events[0].action,
        name: this.configData.name,
        component: this,
        configData: this.configData,
        data: "",
      };
     this.apiService._commonComponentSubject.next(eventData);
    }

  }
}
